import React from "react";
import { Box, Button, Typography } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error (optional: send to monitoring service)
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f7f7f7",
          }}
        >
          <Box
            sx={{
              p: 4,
              background: "white",
              borderRadius: 2,
              maxWidth: 500,
              textAlign: "center",
              boxShadow: 3,
            }}
          >
            <Typography variant="h5" color="error" gutterBottom>
              Something went wrong
            </Typography>

            <Typography sx={{ mb: 2, color: "#555" }}>
              We're unable to display this page right now.  
              Please try again.
            </Typography>

            <Button
              variant="contained"
              color="primary"
              onClick={this.handleRetry}
            >
              Reload Page
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
